export default "__VITE_ASSET__Dej4QOLt__"